import { render, staticRenderFns } from "./Login-Layout.vue?vue&type=template&id=81385cc4&scoped=true"
import script from "./Login-Layout.vue?vue&type=script&lang=js"
export * from "./Login-Layout.vue?vue&type=script&lang=js"
import style0 from "./Login-Layout.vue?vue&type=style&index=0&id=81385cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81385cc4",
  null
  
)

export default component.exports